// Import scripts
// Styles
import '../sass/main.scss';

// Import asset images
// import './images';

// Import javascript
// import debounce from './helpers/debounce';
import activeTrigger from './helpers/activeTrigger';

import siteNav from './components/siteNav';
import customSelect from './components/customSelect';
import pathways from './components/pathways';
import teaserTabs from './components/teaserTabs';
import profilePopup from './components/profilePopup';
import alerts from './components/alerts';
import loadMore from './components/loadMore';
import programFinder from './components/programFinder';
import swiper from './components/swiper';
import acalog from './components/acalog/acalog';
import videos from './components/videos';
import filters from './components/filters';
import officeFilters from './components/officeFilters';
import firstSection from "./components/firstSection";
import { initializeRadioButtons } from "./components/utilities/radioUncheck";

jQuery(document).ready(function () {
  window.addEventListener('resize', () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });

  activeTrigger();
  siteNav(jQuery);
  customSelect(jQuery);
  pathways(jQuery);
  teaserTabs(jQuery);
  profilePopup(jQuery);
  alerts(jQuery);
  loadMore(jQuery);
  programFinder(jQuery);
  swiper();
  videos();
  filters(jQuery);
  officeFilters(jQuery);
  firstSection(jQuery);
  initializeRadioButtons();
});